import Error404Image from './img/404.png';
import Error500Image from './img/500.png';

export { Error500Image, Error404Image };
